const vi = {
  10000001: 'Lễ kỷ niệm 2 năm SuperEx',
  10000002: 'Đăng nhập để nhận phần thưởng lớn!',
  10000003: 'Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 10 000USDT',
  10000004: 'Kỷ niệm hai năm của SuperEx',
  10000005: 'Giành được 20.000 USDT trong Cuộc thi giao dịch hợp đồng tương lai',
  10000006: `Cuộc thi xếp hạng khối lượng giao dịch: Mở khóa giải thưởng cao nhất là quỹ tiền thưởng <span style="color: #ffc72b;">10,000</span> USDT`,
  10000007: 'Giải vô địch tương lai',
  10000008: 'Giành được 20.000 USDT trong Cuộc thi giao dịch hợp đồng tương lai',

  10000009: 'Chọn',
  10000010: 'Tổng cung',
  10000011: 'Explorer',
  10000012: 'Trở về',
  10000013: 'Tiếp theo',
  10000014: 'Trước',
  10000015: 'Điền thông tin',
  10000016: 'Vui lòng nhập tên token',
  10000017: 'Vui lòng nhập tên đầy đủ của token.',
  10000018: 'Đã hiểu',
  10000019: 'Vui lòng nhập tên của phiên bản cặp giao dịch.',
  10000020: 'Vui lòng cung cấp nguồn cung cấp token lưu hành.',
  10000021: 'Hoàn thành',
  10000022: 'Sau đó, bạn có thể xem dữ liệu thống kê của cặp giao dịch này trên trang Free Market của trang web.',
  10000023: '{currency} đã được niêm yết!',
  10000024: 'Năm',
  10000025: 'Tháng',
  10000026: 'Ngày',

  8000067: 'Số liệu thống kê',
  8000068: 'Tên token',
  8000069: 'Chuỗi chính hoặc giao thức',
  8000070: 'Địa chỉ hợp đồng hoặc Ticker',
  8000071: 'Tên phiên bản',
  8000072: 'Thời gian tạo phiên bản',
  8000073: 'Trạng thái phiên bản',
  8000074: 'Số tiền hoa hồng (Tích lũy)/U',
  8000075: 'Số tiền hoa hồng (Tuần trước)/U',
  8000076: 'Số tiền giao dịch (Tuần trước)/U',
  8000077: 'Số lượng giao dịch (Tuần trước)',
  8000078: 'Tạo một cặp giao dịch',
  8000079: 'Tiện ích',
  8000080: 'Đã niêm yết',
  8000081: 'Bị hủy niêm yết',
  8000082: 'Đã hủy niêm yết',
  8000083: 'Chọn token',
  8000084: 'Thông báo danh sách',
  8000085: 'Tạo thành công',
  8000086: 'Niêm yết tại Free Market',
  8000087: 'Tại SuperEx, bạn có thể dễ dàng và miễn phí hoàn thành việc niêm yết trên sàn giao dịch và có cơ hội nhận được tới 80% cổ tức từ phí giao dịch.',
  8000088: 'Hoạt động như thế nào?',
  8000089: 'Tạo một cặp giao dịch mới',
  8000090: 'Tôi sẽ niêm yết đồng coin',
  8000091: 'Tạo phiên bản của cặp giao dịch',
  8000092: 'Sàn giao dịch SuperEx',
  8000093: 'Tại sao chọn chúng tôi?',
  8000094: 'Lựa chọn đa dạng',
  8000095: 'Hỗ trợ nhiều chuỗi và giao thức, bao gồm chuỗi BSC, chuỗi ETH và chuỗi SOL.',
  8000096: 'Niêm yết ngay lập tức mà không cần xác minh thủ công như quy trình phi tập trung và tận hưởng sự tiện lợi của Order Book Trading.',
  8000097: 'Hỗ trợ API',
  8000098: 'Bạn có thể sử dụng giao diện API để thực hiện tạo lập thị trường hoặc giao dịch, giúp các hoạt động của bạn trở nên hiệu quả và tự động hóa hơn.',
  8000099: 'Tiếp cận và Lưu lượng truy cập',
  8000100: 'Bằng cách niêm yết trong Free Market, hãy tận hưởng lưu lượng người dùng khổng lồ của SuperEx và thu hút được nhiều sự chú ý hơn.',
  8000101: 'Cho dù bạn là người mới hay nhà giao dịch có kinh nghiệm, Free Market của chúng tôi sẽ mang đến cho bạn những trải nghiệm và cơ hội đầu tư mới. Tạo các cặp giao dịch của riêng bạn ngay lập tức, quảng cáo đồng  yêu thích của bạn và tận hưởng thu nhập hoa hồng từ phí giao dịch!',
  8000102: 'Tổng tài sản của bạn phải vượt quá {resultData} USDT trước khi bạn đủ điều kiện tạo cặp giao dịch.',
  8000103: 'Liệt kê token yêu thích của bạn',
  8000104: 'Bạn có thể chọn loại tiền điện tử ưa thích của mình và ghép nối nó với USDT để tạo một cặp giao dịch duy nhất.',
  8000105: 'Phí nhận hoa hồng',
  8000106: 'Khi khối lượng giao dịch của phiên bản cặp giao dịch mà bạn tạo đạt đến một ngưỡng nhất định, một phần phí giao dịch sẽ được trả lại cho bạn dưới dạng hoa hồng. Điều này cho phép bạn, với tư cách là người tạo ra phiên bản cặp giao dịch, cũng có thể chia sẻ lợi nhuận giao dịch.',
  8000107: 'Bây giờ bạn là người dùng bị hạn chế và tạm thời không thể tạo các cặp giao dịch mới. Vui lòng thử lại vào ngày mai.',
  8000108: 'Vui lòng chọn một ngôn ngữ',
  8000109: 'White Paper',
  8000110: 'Token đã bị cấm niêm yết!',
  8000111: 'Token này đã được liệt kê trong Main Market SuperEx và bạn không thể tạo một cặp giao dịch khác!',
  8000112: 'Vui lòng nhập địa chỉ hợp đồng/Ticker hợp lệ!',
  8000113: 'Số dư ET trên Bảng chính Spot của bạn không đủ. Để tạo một phiên giao dịch mới, bạn cần thanh toán phí quản lý là {num} ET. Vui lòng nạp tiền và thử lại.',
  8000114: 'Bạn đã nhập quá nhiều thông tin sai trong quá trình tạo cặp giao dịch mới ngày hôm nay. Vì vậy, hôm nay bạn không thể gửi thêm bất kỳ yêu cầu nào nữa. Vui lòng thử lại vào ngày mai.',
  8000115: 'Token đã tồn tại, vì vậy bây giờ chúng tôi sẽ tạo một phiên bản mới của cặp giao dịch cho bạn!',
  8000116: 'Vui lòng xác nhận thông tin sau:',
  8000117: 'Độ dài thập phân của số lượng token',
  8000118: 'Làm thế nào để niêm yết một đồng tiền một cách tự do',
  8000119: 'Tên đầy đủ của token',
  8000120: 'Độ dài thập phân của giá token',
  8000121: 'Niêm yết coin trên SUPEREX: <em class="normal" style="color: #0CAA6D;">0 phí niêm yết! </em><em class="normal" style="color: #1D90F5;">0 chi phí giao tiếp! </em>Hoàn thành niêm yết trên sàn giao dịch trong 1 phút và tận hưởng lợi nhuận lên đến <em class="normal" style="color: #F65D62;">80%</em>',
  8000122: 'Giới thiệu token bằng tiếng Anh',
  8000123: 'Thông tin sau đây là bắt buộc:',
  8000124: 'Tên phiên bản bạn nhập đã tồn tại. Vui lòng nhập một cái khác.',
  8000125: 'Sau đây là thông tin tùy chọn:',
  8000126: 'Vui lòng chọn chuỗi chính hoặc giao thức và phí quản lý tương ứng',
  8000127: 'Bước 1: Sao chép và dán địa chỉ hợp đồng của đồng coin mới.',
  8000128: 'Vui lòng nhập địa chỉ hợp đồng/Ticker',
  8000129: 'Xác nhận',
  8000130: 'Phiên bản cặp giao dịch {currency} của bạn đã được tạo thành công!',
  8000131: 'Bước 2: Nếu đồng tiền này lần đầu tiên được niêm yết trên sàn giao dịch của chúng tôi, bạn cần hoàn thành một số thông tin cơ bản như giới thiệu về đồng tiền và tải lên hình ảnh logo.',
  8000132: 'Thị trường giao thức BTC',
  8000133: 'Bước 3: Bạn chỉ cần đặt tên cho phiên bản của cặp giao dịch mà bạn đã tạo. Sau đó, quy trình niêm yết hoàn thành và đồng tiền có thể được giao dịch công khai.',
  8000134: 'Niêm yết token',
  8000135: 'Vui lòng nhập tổng nguồn cung.',
  8000136: 'Bước 4: Khi khối lượng giao dịch hàng tuần của phiên bản của bạn đạt đến một ngưỡng nhất định, bạn sẽ nhận được một phần của phí giao dịch từ phiên bản đó.',
  8000137: 'Nếu bạn chọn 8, điều đó có nghĩa là giá trị giá của tiền điện tử của bạn được hiển thị chính xác đến 0.00000001. Ví dụ, giá BTC hiển thị là $72186.12345678. Đối với hầu hết các đồng MEME, chúng tôi khuyên bạn nên chọn 11.',
  8000138: 'Vui lòng nhập',
  8000139: 'Tôi sẽ bắt đầu niêm yết đồng coin',
  8000140: 'Vui lòng nhập mô tả ngắn gọn về token bằng tiếng Anh.',
  8000141: 'Bạn có thể đơn giản hiểu "instance" là các phiên bản khác nhau của cùng một cặp giao dịch, trong đó một phiên bản là instance do bạn tạo ra. Người dùng khác phân biệt các phiên bản này qua tên instance. Chỉ cần người dùng chọn instance của bạn để giao dịch, bạn sẽ có cơ hội nhận được phần hoa hồng phí giao dịch tương ứng.',
  8000142: 'Định dạng email không đúng.',
  8000143: 'Vui lòng nhập địa chỉ truy vấn blockchain.',
  8000144: 'Nguồn cung lưu thông',
  8000145: 'Nguồn cung lưu hành được giới hạn ở 1-20 chữ số dưới dạng số nguyên dương.',
  8000146: 'Biểu tượng token',
  8000147: 'Hỗ trợ định dạng PNG hoặc JPG, giới hạn kích thước tệp là 5 MB và bạn có thể tải lên tối đa 10 lần mỗi ngày.',
  8000148: 'Ngày phát hành',
  8000149: 'Vui lòng chọn ngày phát hành.',
  8000150: 'Vui lòng cung cấp liên kết tới WhitePaper.',
  8000151: 'Trang web chính thức',
  8000152: 'Vui lòng cung cấp liên kết trang web chính thức.',
  8000153: 'Niêm yết Free Market',
  8000154: 'Đưa token của bạn niêm yết trên sàn giao dịch',
  8000155: 'Giới hạn đầu vào cho Tên Token là 9 ký tự, và chỉ hỗ trợ các số, chữ cái tiếng Anh và ký hiệu tiếng Anh',
  8000156: 'Giới hạn đầu vào cho tên đầy đủ của Token là 50 ký tự, và chỉ hỗ trợ các số, dấu cách, chữ cái tiếng Anh và ký hiệu tiếng Anh',
  8000157: 'Tổng nguồn cung phải là số nguyên dương có từ 1 đến 20 chữ số.',
  8000158: 'Ký tự bắt đầu hoặc kết thúc không thể là khoảng trắng và không thể có các khoảng trắng liên tục. Ký hiệu "/" và biểu tượng cảm xúc không được hỗ trợ.',
  8000159: '1. Nhà phát hành chịu trách nhiệm về tính xác thực của thông tin và nền tảng có quyền xóa token hoặc phiên bản cặp giao dịch bất kỳ lúc nào và điều chỉnh nội dung thông tin bất kỳ lúc nào.',
  8000160: '2. Tổ chức phát hành được yêu cầu tiến hành nghiên cứu kỹ lưỡng về token được liệt kê và chịu trách nhiệm về tính hợp lý, tuân thủ và hợp pháp của nó. Nếu nền tảng phát hiện bất kỳ hành vi hoặc nội dung độc hại hoặc có hại hoặc cụ thể nào khác trong hợp đồng thông minh của token, nền tảng sẽ xóa token trực tiếp và đại diện cho người dùng khiếu nại chống lại nhà phát hành.',
  8000161: '3. Nếu nhà phát hành hoặc bất kỳ ai khác muốn điều chỉnh thông tin token sau này, họ cần liên hệ với bộ phận dịch vụ khách hàng của chúng tôi.',
  8000162: '4. Để bảo vệ lợi ích của người dùng và loại bỏ các token kém chất lượng, nếu phiên bản cặp giao dịch do nhà phát hành tạo ra không đáp ứng các yêu cầu về hoạt động giao dịch trên nền tảng của chúng tôi, thì nhà phát hành sẽ được thông báo hủy niêm yết khoảng một tuần sau đó. Thứ hai hàng tuần, nền tảng sẽ gửi thông báo hủy niêm yết qua email và thông báo ứng dụng đối với các trường hợp không tuân thủ tới tổ chức phát hành. Và các tổ chức phát hành sẽ có cơ hội nộp đơn xin gia hạn niêm yết trong vòng 5 ngày. Nếu đơn đăng ký thành công, sẽ được cấp thêm 4 tuần thời gian quan sát; nếu không, các phiên bản sẽ bị hủy bỏ.',
  8000163: '5. Nếu bản sao của cặp giao dịch được tạo bởi nhà phát hành token đáp ứng ngưỡng cổ tức của nền tảng về khối lượng giao dịch, họ sẽ nhận được cổ tức phí tương ứng.',
  8000164: 'Bạn có sẵn lòng cung cấp một số lượng token nhất định cho các hoạt động vận hành và tiếp thị để mở rộng ảnh hưởng của đồng coin không?',
  8000165: '6. Nhà phát hành có thể liên hệ với bộ phận dịch vụ khách hàng của chúng tôi để đăng ký Market Maker.',
  8000166: 'Tạo',
  8000167: 'Bạn sắp tạo một phiên bản của cặp giao dịch {currency} và trừ {upFee} ET từ tài khoản Sàn giao dịch chính của bạn.',
  8000168: 'Không',
  8000169: 'Vâng',
  8000170: 'Vui lòng nhập địa chỉ email của bạn để đội ngũ tiếp thị của chúng tôi có thể liên hệ với bạn',
  8000171: 'Bạn có người giới thiệu hoặc người liên hệ không?',
  8000172: 'Vui lòng nhập tên hoặc thông tin liên hệ của người giới thiệu.',
  8000173: 'Bằng cách nhấp vào hộp kiểm này, bạn xác nhận tất cả các rủi ro liên quan và đồng ý với <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">Điều khoản và Điều kiện</a> của chúng tôi.',
  8000174: 'Lợi nhuận từ việc niêm yết',
  8000175: 'Quyền niêm yết trên sàn giao dịch',
  8000176: 'Mã thông báo này hiện không được hỗ trợ để niêm yết!',
  8000177: 'Điền thông tin',
  8000178: 'Đi chia sẻ',
  8000179: 'đã được niêm yết!',
  8000180: 'SuperEx Free Market, thế giới tiền điện tử của người dùng, do người dùng, vì người dùng',
  8000181: 'Tôi đã tạo một cặp giao dịch {symbol} trên SuperEx! Lên mặt trăng!',
  8000182: 'Số tiền cổ tức cho mỗi giao dịch được cập nhật vào thứ Hai, nhưng có thể có sự chậm trễ lên đến 3 ngày làm việc trong quá trình phân phối thực tế. Bạn có thể kiểm tra các bản ghi liên quan dưới "Lịch sử Ví" - "Khác" - "Thị trường Chính" thông qua loại "Gửi phần thưởng".',
  8000183: 'Tài khoản Twitter',
  8000184: 'Tài khoản Telegram',
  8000185: 'Tài khoản Discord',
  8000186: 'Vui lòng nhập liên kết Twitter hợp lệ!',
  8000187: 'Vui lòng nhập liên kết Telegram hợp lệ!',
  8000188: 'Vui lòng nhập liên kết Discord hợp lệ!',
  8000189: 'Vui lòng nhập liên kết Twitter',
  8000190: 'Vui lòng nhập liên kết Telegram',
  8000191: 'Vui lòng nhập liên kết Discord',
  8000192: 'Xin lỗi, nội dung hoặc cài đặt quyền liên quan của hợp đồng thông minh cho loại tiền tệ này có rủi ro bảo mật cao. Vui lòng thử sử dụng loại tiền tệ khác.',
  8000193: 'Xin lỗi, nội dung của hợp đồng thông minh cho loại tiền tệ này có thể có rủi ro tiềm ẩn. Hiện tại không thể niêm yết. Vui lòng thử sử dụng loại tiền tệ khác.',
  8000194: 'Lưu ý:',
  8000195: 'Bạn cần hoàn tất việc nạp tiền cho mã thông báo này trước khi có thể đặt lệnh bán.',
  8000196: 'Bạn cần chuyển USDT vào Tài Khoản Free Market trước khi có thể đặt lệnh mua.',
  8000197: 'Bạn cần kết nối API trước khi có thể tham gia giao dịch tạo thị trường.',
  8000198: 'Liên hệ dịch vụ khách hàng',
  8000199: 'Vui lòng nhập một số nguyên từ 5 đến 12',

  8100013: 'Kênh xác minh chính thức',
  8100014: 'Vui lòng nhập thông tin bạn muốn xác minh',
  8100015: 'Bạn có thể xác minh các nội dung sau',
  8100016: 'Chỉ cho phép các email chính thức từ SUPEREX.COM',
  8100017: 'Xác minh danh tính BD chính thức',
  8100018: 'Ví dụ: tài khoản chính thức Telegram/X(Twitter)',
  8100019: 'Xác minh kênh niêm yết',
  8100020: 'Nếu bạn cần ký hợp đồng hoặc thực hiện thanh toán, vui lòng xác nhận với BD chính thức',
  8100021: 'Cảm ơn bạn đã quan tâm đến <a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>, chúng tôi sẽ cố gắng hết sức để bảo vệ quyền lợi của mọi người.',
  8100022: 'Kênh không chính thức của SuperEx',
  8100023: 'Kênh chính thức của SuperEx',
  8100024: 'Giá trị <em class="normal activeColor" style="word-break: break-word">{keyWord}</em> bạn nhập không phải là kênh chính thức của SuperEx. Vui lòng đảm bảo an toàn tài sản của bạn và bảo vệ thông tin cá nhân của bạn.',
  8100025: 'Địa chỉ <em class="normal activeColor" style="word-break: break-word">{keyWord}</em> trong yêu cầu của bạn là {note}.',
  8100026: 'Mẹo bảo mật',
  8100027: '· Không tương tác với các tài khoản chưa được xác minh.',
  8100028: '· Không tiết lộ cụm từ ghi nhớ ví, email đã đăng ký với SuperEx, số điện thoại và/hoặc mật khẩu của bạn cho bất kỳ ai.',
  8100029: '· Nếu bạn cần hỗ trợ thêm, vui lòng liên hệ với bộ phận hỗ trợ khách hàng tại support@superex.com.',
  8100030: 'Nhận được món quà lớn từ {userName}!',
  8100031: 'Mở quà',
  8100032: 'Còn lại một bước cuối cùng!',
  8100033: 'Tải xuống SuperEx ngay và nhận quà bạn bè!',
  8100034: 'Bỏ qua quà',
}

export default vi



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/vi.js